<div
    class="toogle-switch-container"
    [ngClass]="{ 'is-neutral': switchState === '', 'is-accepted': switchState === 'y', 'is-reyected': switchState === 'n' }"
>
    <button
        class="toogle-switch-button button-no"
        type="button"
        (click)="onclickNo()"
        [ngClass]="{ 'is-neutral': switchState === '', 'is-accepted': switchState === 'y', 'is-reyected': switchState === 'n' }"
    >
        <span class="">No</span>
    </button>

    <div
        class="separator"
        [ngClass]="{ 'is-neutral': switchState === '', 'is-accepted': switchState === 'y', 'is-reyected': switchState === 'n' }"
    ></div>

    <button
        class="toogle-switch-button button-yes"
        type="button"
        (click)="onclickYes()"
        [ngClass]="{ 'is-neutral': switchState === '', 'is-accepted': switchState === 'y', 'is-reyected': switchState === 'n' }"
    >
        <span class="">Si</span>
    </button>
</div>
